module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/iPhone-x-back-dd00240b7bc0a3775dbd42abe04950ca.svg";